export interface CalendarLegends {
  legend_label: string;
  flag_color: string;
}

export interface CalendarLegends2 {
  legend_label: string;
  flag_title: string;
}

export interface ApplyLeave {
  leave_type: string;
  leave_type_id: string;
  from_date: Date | string;
  to_date: Date | string;
  start_time: string;
  end_time: string;
  leave_purpose: string;
  leave_purpose_other: string;
  leave_description: string;
  leave_id?: string;
  document?: any;
}

export interface LeaveDetail {
  financial_year: string;
  financial_year_end_from: string;
  financial_year_start_from: string;
  leave_id: string;
  user_id: string;
  lev_applied_by: string;
  lev_applied_comment: string;
  lev_approved_by: string;
  lev_approved_comment: string;
  lev_approved_on: Date | string;
  lev_created_date: Date | string;
  lev_customer_track_id: string;
  lev_end_date: Date | string;
  lev_end_time: string;
  lev_flag: string;
  lev_purpose: string;
  lev_start_date: Date | string;
  lev_start_time: string;
  lev_status: string;
  lev_totalDays: string;
  lev_type: string;
  lev_updated_date: Date | string;
  lev_user_track_id: string;
  total_companyleaves: string;
  approverDetails: {
    approved_first_name: string;
    approved_last_name: string;
  }[];
  userDetails: {
    emp_id: string;
    first_name: string;
    last_name: string;
  }[];
  leave_modified_status: string;
  status: string;
  medicalCertificate: string;
  leave_type?: string;
  leave_frequency?: string;
  limit?: number;
  offset?: number;
  total_records?: number;
  approverFullName?: string;
}

export interface LeaveRequestDetail {
  comments: [{ user_id: string; comments: string }];
  leave_id: string;
  lev_end_date: Date | string;
  lev_purpose: string;
  lev_start_date: Date | string;
  lev_status: string;
  lev_totalDays: string;
  lev_type: string;
  lev_user_track_id: string;
  usr_empID: string;
  user_last_name: string;
  user_first_name: string;
  total_records: number;
  offset: number;
  limit: number;
}

export interface ChangeLeaveStatus {
  leave_id: string;
  comments: string;
  leave_status: string;
}

export interface CancelLeave {
  leave_id: string;
  leave_start_date: Date | string;
}

export interface LeaveOverview {
  currentYear: string,
  firstDate: Date | string,
  noDaysinMoth: string,
}

export interface LeavesTypes {
  name: string;
  value: string;
  leave_type_id: string;
  leave_type: string;
  leaveType?: string;
  leaveFrequency?: string;
}